import VipDetail from '@/pages/vip/vip-detail/index';
import ManagementListPage from '@/pages/vip/management-list'

export const vipDetail = {
  path: 'Vip/vipDetail',
  component: VipDetail
}

// 会员管理列表页
export const managementList = {
  path: 'vip/managementList',
  component: ManagementListPage
}


// WEBPACK FOOTER //
// ./src/router/vip.js